export const SM_MIN = '481'
export const MD_MIN = '769'
export const LG_MIN = '1281'
export const XL_MIN = '1691'

export const SIDEBAR_MAX = '1490'
